
import { mapState } from 'vuex'
import tasks from '@/components/tools/tasks'

export default {

  props: {
    xOffset: {
      type: Number,
      default: 0
    },
    groupKey: {
      type: String,
      default: undefined
    }
  },

  computed: {
    ...mapState('messages', {
      boards: state => state.boards,

      ctaOffset () {
        if (this.openReadMes >= 10) {
          return 20
        } else {
          return 15
        }
      },
      openCtas (state) {
        if (this.groupKey) {
          const messages = this.boards[this.groupKey]
          if (messages && messages.length > 0) {
            const message = messages[messages.length - 1]
            if (tasks.hasOpenCta(message)) {
              return 1
            }
          }
          return 0
        } else {
          return state.openCtas
        }
      },
      openReadMes (state) {
        if (this.groupKey) {
          const messages = this.boards[this.groupKey]
          if (messages && messages.length > 0) {
            return tasks.computeOpenReadMes(messages)
          }
          // return tasks.computeOpenReadMes(this.messages)
        } else {
          return state.openReadMes
        }
      }
    }),
    messages () {
      const messages = this.boards[this.groupKey]
      if (messages) {
        return messages
      } else {
        return []
      }
    }
  }

}
